import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "d-flex flex-fill align-items-center" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = { class: "me-2 mb-0" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Navn ")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "require-field" }, "*", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" CVR-nummer ")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "require-field" }, "*", -1)
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h6", { class: "mb-3" }, "Notifikationsindstillinger", -1)
const _hoisted_10 = { class: "form-check mt-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "notifiedOnChange"
}, " Notificer ved ændringer i organisationen ", -1)
const _hoisted_12 = { class: "form-check mt-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "notifiedOnUserChange"
}, " Notificer ved brugerændringer ", -1)
const _hoisted_14 = { class: "form-check mt-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "notifiedOnRoleAssignmentChange"
}, " Notificer ved rolletildelingsændringer ", -1)
const _hoisted_16 = {
  key: 0,
  class: "mt-5 p-5 bg-info flex-grow-1"
}
const _hoisted_17 = { class: "d-flex align-items-start mb-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h2", null, "Roller", -1)
const _hoisted_19 = { class: "ms-auto d-flex gap-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" + Tilføj rolleprofil ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" + Tilføj rolle ")
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "d-flex justify-content-end" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Slet ")
const _hoisted_27 = { class: "d-flex justify-content-end" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Afbryd")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Error = _resolveComponent("Error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_RolePicker = _resolveComponent("RolePicker")!
  const _component_RoleProfilePicker = _resolveComponent("RoleProfilePicker")!
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    draggable: false,
    modal: true,
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isVisible = $event)),
    style: { width: _ctx.canViewOrganizationRoles ? '50rem' : '' },
    class: "appension"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h5", _hoisted_3, _toDisplayString(_ctx.organization ? "Rediger organisation" : "Opret organisation"), 1)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", {
        class: ["appension", { 'd-flex justify-content-between': _ctx.organization }]
      }, [
        (_ctx.organization)
          ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_25, [
              (_ctx.canManageOrg && !_ctx.isUnknownOrganization())
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _ctx.deleteOrganization,
                    class: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        class: "me-2",
                        spin: _ctx.deleteOrganizationMutation.loading.value,
                        icon: 
                _ctx.deleteOrganizationMutation.loading.value
                  ? ['fas', 'spinner']
                  : ['fas', 'trash']
              
                      }, null, 8, ["spin", "icon"]),
                      _hoisted_26
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 512)), [
              [_directive_tooltip, {
            value: 'Alle brugere skal slettes først!',
            disabled: (_ctx.organization?.users?.items?.length ?? 0) < 1,
          }]
            ])
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_27, [
          _createVNode(_component_Button, {
            onClick: _ctx.hide,
            class: "link me-2"
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.canManageOrg)
            ? (_openBlock(), _createBlock(_component_VDButton, {
                key: 0,
                isDisabled: _ctx.v$.$error || !_ctx.hasChanges,
                variant: "primary",
                onClick: _ctx.primaryButtonPressed,
                isLoading: 
              _ctx.updateOrganizationMutation.loading.value ||
              _ctx.createOrganizationMutation.loading.value
            
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.organization ? "Gem" : "Opret"), 1)
                ]),
                _: 1
              }, 8, ["isDisabled", "onClick", "isLoading"]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_o_field, {
        variant: _ctx.v$.name.$error ? 'danger' : ''
      }, {
        label: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        default: _withCtx(() => [
          _createVNode(_component_o_input, {
            ref: "nameInput",
            modelValue: _ctx.newOrganization.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newOrganization.name = $event)),
            disabled: _ctx.isUnknownOrganization()
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["variant"]),
      _createVNode(_component_o_field, {
        variant: _ctx.v$.vat.$error ? 'danger' : '',
        class: "mt-3"
      }, {
        label: _withCtx(() => [
          _hoisted_6,
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_component_o_input, {
            modelValue: _ctx.newOrganization.vat,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newOrganization.vat = $event)),
            disabled: _ctx.isUnknownOrganization() || !_ctx.canManageOrg
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["variant"]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _withDirectives(_createVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newOrganization.notifiedOnChange = $event)),
            id: "notifiedOnChange"
          }, null, 512), [
            [_vModelCheckbox, _ctx.newOrganization.notifiedOnChange]
          ]),
          _hoisted_11
        ]),
        _createVNode("div", _hoisted_12, [
          _withDirectives(_createVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newOrganization.notifiedOnUserChange = $event)),
            id: "notifiedOnUserChange"
          }, null, 512), [
            [_vModelCheckbox, _ctx.newOrganization.notifiedOnUserChange]
          ]),
          _hoisted_13
        ]),
        _createVNode("div", _hoisted_14, [
          _withDirectives(_createVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.newOrganization.notifiedOnRoleAssignmentChange = $event)),
            id: "notifiedOnRoleAssignmentChange"
          }, null, 512), [
            [_vModelCheckbox, _ctx.newOrganization.notifiedOnRoleAssignmentChange]
          ]),
          _hoisted_15
        ])
      ]),
      (_ctx.canViewOrganizationRoles)
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_Button, {
                  disabled: _ctx.addRemoveLoading,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.roleProfilePicker?.toggle($event))),
                  class: "secondary"
                }, {
                  default: _withCtx(() => [
                    (_ctx.addRemoveLoading)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          class: "me-2",
                          spin: "",
                          icon: ['fas', 'spinner']
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_Button, {
                  disabled: _ctx.addRemoveLoading,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rolePicker?.toggle($event))),
                  class: "secondary"
                }, {
                  default: _withCtx(() => [
                    (_ctx.addRemoveLoading)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          class: "me-2",
                          spin: "",
                          icon: ['fas', 'spinner']
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_21
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _createVNode(_component_DataTable, {
              stripedRows: true,
              sortOrder: 1,
              responsiveLayout: "scroll",
              value: _ctx.newOrganization?.assigneeRoles,
              class: "text-start",
              selectionMode: "single"
            }, {
              empty: _withCtx(() => [
                _createVNode(_component_Error, { error: {
              title: 'Ingen roller',
              message:
                'Der er ikke nogle roller tilknyttet organisationen endnu',
            } })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "name",
                  sortable: true
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("small", _hoisted_23, _toDisplayString(data.applicationName), 1),
                      _createTextVNode(" " + _toDisplayString(data.roleName), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, null, {
                  body: _withCtx(({ data }) => [
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_Button, {
                        disabled: _ctx.addRemoveLoading,
                        onClick: ($event: any) => (_ctx.removeRole(data)),
                        class: "danger inverted"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_RolePicker, {
        ref: "rolePicker",
        addedRoles: (_ctx.newOrganization?.assigneeRoles || []).filter(role => role != null) as any,
        disabled: !_ctx.canViewOrganizationRoles || _ctx.addRemoveLoading,
        onAddedRole: _ctx.addRole
      }, null, 8, ["addedRoles", "disabled", "onAddedRole"]),
      _createVNode(_component_RoleProfilePicker, {
        ref: "roleProfilePicker",
        disabled: !_ctx.canViewOrganizationRoles || _ctx.addRemoveLoading,
        onProfileSelected: _ctx.addProfileRoles
      }, null, 8, ["disabled", "onProfileSelected"])
    ]),
    _: 1
  }, 8, ["visible", "style"]))
}